import { createContext, useContext } from 'react';
const EMPTY_PRODUCT_EDIT_MODAL_CONTEXT = {
  isEditModalOpen: false,
  setIsEditModalOpen: () => {}
};
export const ProductEditModalContext = /*#__PURE__*/createContext(EMPTY_PRODUCT_EDIT_MODAL_CONTEXT);
export const useProductEditModal = () => {
  const context = useContext(ProductEditModalContext);
  if (context === undefined) {
    throw new Error('ProductEditModalContext data is undefined. useProductEditModalContext must be used within a ProductEditModalContext.Provider');
  }
  return context;
};